/**
 * PATH: packages/ui/src/kanban/card-surface/controls/CardActionButton.tsx
 * FILE_ID: UI-KANBAN-CARDSURFACE-ACTIONBUTTON-001
 * PURPOSE: Provide the shared native button primitive for card action controls.
 * WHY: Card controls need one type-safe base without widening the global Button API.
 * FLOW: native button props + card tokens → consistent action target.
 * DEPENDENCIES: react.
 * RELATED: CardActionCluster.tsx; components/KanbanCardActionZone.tsx.
 */
import type { ButtonHTMLAttributes } from 'react'

export type CardActionButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export function CardActionButton({
  type = 'button',
  ...props
}: CardActionButtonProps) {
  return <button type={type} {...props} />
}
